const formatter = new Intl.NumberFormat('es-CL');

function formatCurrency(value: string | number) {
  return `$ ${formatter.format(parseInt(value.toString(), 10))}`;
}

export { formatCurrency };
